// App Imports
import {IMAGE_SOURCE_PATH } from '../../../setup/config/env'
import params from '../../../setup/config/params'
import List from '../List'
import createOrUpdateCrm from '../contacts/CreateOrUpdate'
import Detail from '../Detail'
import contacts from "../contacts/list"
import Yelp from "../Yelp"
import BulkCreate from '../bulkCreate'
import ClientConfig from '../clientConfig'
import CreateOrUpdate from '../clientConfig/CreateOrUpdate'
import PlanLimitList from '../planLimit/index'
import PlanLimitCreateOrUpdate from '../planLimit/CreateOrUpdate'
import SaasConfigCreateOrUpdate from '../saasConfig/CreateOrUpdate'
import Unsubscribed from '../Unsubscribed/index'
import { defaultImage } from '../../common/Sidebar'

// Image
export function getImageSource(image = defaultImage) {
  return `${ IMAGE_SOURCE_PATH }${ image }`
}


// Rewards and Goals routes
export default {
  crmUnsubscribed: {
    path: '/crm/unsubscribed',
    component: Unsubscribed,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm",
    action: "canView",
  },
  listCrmTabs: {
    path: '/crm',
    component: List,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm",
    action: "canView",
  }, 
  listContacts: {
    path: '/crm',
    component: contacts,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm",
    action: "canView",
  },
  createContact: {
    path: '/crm/create/contacts',
    component: createOrUpdateCrm,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.contacts",
    action: "canCreate",
  },
  createLeads: {
    path: '/crm/create/leads',
    component: createOrUpdateCrm,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.lead",
    action: "canCreate",
  },
  createProspect: {
    path: '/crm/create/prospect',
    component: createOrUpdateCrm,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.prospect",
    action: "canCreate",
  },
  createCustomer: {
    path: '/crm/create/customer',
    component: createOrUpdateCrm,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.customer",
    action: "canCreate",
  },
  editContact: {
    path: (id = ":contactId") => (`/crm/edit/contacts/${ id }`),
    component: createOrUpdateCrm,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.contacts",
    action: "canEdit",
  },
  editContactAlt: {
    path: (id = ":contactId") => `/crm/edit/contact/${id}`,
    component: createOrUpdateCrm,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.contacts",
    action: "canEdit",
  },
  editLead: {
    path: (id = ":contactId") => `/crm/edit/leads/${id}`,
    component: createOrUpdateCrm,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.lead",
    action: "canEdit",
  },
  editLeadAlt: {
    path: (id = ":contactId") => `/crm/edit/lead/${id}`,
    component: createOrUpdateCrm,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.lead",
    action: "canEdit",
  },
  editProspect: {
    path: (id = ":contactId") => `/crm/edit/prospect/${id}`,
    component: createOrUpdateCrm,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.prospect",
    action: "canEdit",
  },
  editProspectAlt: {
    path: (id = ":contactId") => `/crm/edit/prospects/${id}`,
    component: createOrUpdateCrm,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.prospect",
    action: "canEdit",
  },
  editCustomer: {
    path: (id = ":contactId") => `/crm/edit/customer/${id}`,
    component: createOrUpdateCrm,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.customer",
    action: "canEdit",
  },
  editCustomerAlt: {
    path: (id = ":contactId") => `/crm/edit/customers/${id}`,
    component: createOrUpdateCrm,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.customer",
    action: "canEdit",
  },
  editGeneral: {
    path: (tab = ":tab", id = ":contactId") => `/crm/edit/${tab}/${id}`,
    component: createOrUpdateCrm,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm",
    action: "canEdit",
  },
  viewContact: {
    path: (id = ":contactId") => `/crm/view/contacts/${id}`,
    component: Detail,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.contacts",
    action: "canView",
  },
  viewLead: {
    path: (id = ":contactId") => `/crm/view/leads/${id}`,
    component: Detail,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.lead",
    action: "canView",
  },
  viewProspect: {
    path: (id = ":contactId") => `/crm/view/prospect/${id}`,
    component: Detail,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.prospect",
    action: "canView",
  },
  viewCustomer: {
    path: (id = ":contactId") => `/crm/view/customer/${id}`,
    component: Detail,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.customer",
    action: "canView",
  },
  viewGeneral: {
    path: (tab = ":tab", id = ":contactId") => `/crm/view/${tab}/${id}`,
    component: Detail,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm",
    action: "canView",
  },
  viewById: {
    path: (id = ":contactId") => `/crm/view/${id}`,
    component: Detail,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm",
    action: "canView",
  },
  yelp: {
    path: '/crm/yelp',
    component: Yelp,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.yelp",
    action: "canCreate",
  },
  bulkUpload: {
    path:'/crm/bulkUpload',
    component: BulkCreate,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm",
    action: "canCreate",
  },
  clientConfig: {
    path: '/crm/clientConfig',
    component: ClientConfig,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.clientConfig",
    action: "canView",
  },
  createorUpdateclientConfig: {
    path: '/crm/createOrUpdate',
    component: CreateOrUpdate,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "engagement",
    subModule: "crm.clientConfig",
    action: "canView",
  }  
};
